import styled from '@emotion/styled';
import { Box, BoxProps, createPolymorphicComponent } from '@mantine/core';

export const PageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const PageTop = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 30px;
  background: ${props => props.theme.white};
  border-bottom: 1px solid ${props => props.theme.colors.gray[2]};
`;

export const PageTopLeft = styled.div`
  flex: 1 1 auto;
`;

export const PageContentWrapper = styled.div`
  flex: 1 1 auto;
  width: 100%;
  overflow-y: auto;
`;

export const PageContent = createPolymorphicComponent<'div', BoxProps>(styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin: 0 auto;
`);

export const PageChildren = createPolymorphicComponent<'div', BoxProps>(styled(Box)`
  position: relative;
  flex: 1 1 auto;
`);

export const PageBottom = styled.div`
  min-height: 61px;
  background: ${props => props.theme.white};
  border-top: 1px solid ${props => props.theme.colors.gray[2]};

  > div {
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    padding: 0 15px;

    > div {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      padding: 7px 0;

      &.left {
        justify-content: flex-start;
      }

      &.right {
        justify-content: flex-end;
      }
    }
  }
`;
